<template>
  <!-- 添加客户 -->
  <div class="invitateIsPolite">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>营销</el-breadcrumb-item>
      <el-breadcrumb-item>邀请有礼</el-breadcrumb-item>
      <el-breadcrumb-item>推荐设置</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="basicInfo">
      <h3 class="title-t mg-b-30">基础信息</h3>
      <el-form ref="form" :model="basicInfoForm" label-width="150px">
        <el-form-item label="" prop="name" style="margin-left: -84px">
          <div class="flex align-center mg-t-10">
            <p>
              每邀请一名当前页成功推荐亲友完成项目服务预约，
              奖励优惠券
              <el-select v-model="basicInfoForm.coupon_uuid" placeholder="请选择">
                <el-option
                  v-for="item in tableData"
                  :key="item.uuid"
                  :label="item.name"
                  :value="item.uuid">
                </el-option>
              </el-select>
              <!-- <el-input
                v-model="basicInfoForm.coupon_uuid"
                class="ipt"
                placeholder="请输入"
                ><template slot="prepend">奖励</template></el-input
              > -->
            </p>
            <p>
              ，每日最多可获得<el-input
                v-model="basicInfoForm.day_limit"
                class="ipt"
                placeholder="请输入"
                ><template slot="prepend">次</template></el-input
              >
            </p>
          </div>
        </el-form-item>
        <h2 class="color-333 mg-b-20" style="margin-left: 66px">
          阶段奖励设置
        </h2>
        <el-form-item label="阶段奖励一" prop="stage_1_num">
          <div class="flex align-center">
            <p>
              每累积邀请<el-input
                v-model="basicInfoForm.stage_1_num"
                class="ipt"
                placeholder="请输入"
                ><template slot="prepend">人</template></el-input
              >
            </p>
            <p>
              可额外获得奖励
              <el-select v-model="basicInfoForm.stage_1_coupon" placeholder="请选择">
                <el-option
                  v-for="item in tableData"
                  :key="item.uuid"
                  :label="item.name"
                  :value="item.uuid">
                </el-option>
              </el-select>
            </p>
          </div>
        </el-form-item>
        <el-form-item label="阶段奖励二" prop="stage_2_num">
          <div class="flex align-center">
            <p>
              每累积邀请<el-input
                v-model="basicInfoForm.stage_2_num"
                class="ipt"
                placeholder="请输入"
                ><template slot="prepend">人</template></el-input
              >
            </p>
            <p>
              可额外获得奖励
              <el-select v-model="basicInfoForm.stage_2_coupon" placeholder="请选择">
                <el-option
                  v-for="item in tableData"
                  :key="item.uuid"
                  :label="item.name"
                  :value="item.uuid">
                </el-option>
              </el-select>
            </p>
          </div>
        </el-form-item>
        <el-form-item label="阶段奖励三" prop="stage_3_num">
          <div class="flex align-center">
            <p>
              每累积邀请<el-input
                v-model="basicInfoForm.stage_3_num"
                class="ipt"
                placeholder="请输入"
                ><template slot="prepend">人</template></el-input
              >
            </p>
            <p>
              可额外获得奖励
              <el-select v-model="basicInfoForm.stage_3_coupon" placeholder="请选择">
                <el-option
                  v-for="item in tableData"
                  :key="item.uuid"
                  :label="item.name"
                  :value="item.uuid">
                </el-option>
              </el-select>
            </p>
          </div>
        </el-form-item>
        <el-form-item label="阶段奖励四" prop="stage_4_num">
          <div class="flex align-center">
            <p>
              每累积邀请<el-input
                v-model="basicInfoForm.stage_4_num"
                class="ipt"
                placeholder="请输入"
                ><template slot="prepend">人</template></el-input
              >
            </p>
            <p>
              可额外获得奖励
              <el-select v-model="basicInfoForm.stage_4_coupon" placeholder="请选择">
                <el-option
                  v-for="item in tableData"
                  :key="item.uuid"
                  :label="item.name"
                  :value="item.uuid">
                </el-option>
              </el-select>
             
            </p>
          </div>
        </el-form-item>
        <el-form-item label="阶段奖励五" prop="stage_5_num">
          <div class="flex align-center">
            <p>
              每累积邀请<el-input
                v-model="basicInfoForm.stage_5_num"
                class="ipt"
                placeholder="请输入"
                ><template slot="prepend">人</template></el-input
              >
            </p>
            <p>
              可额外获得奖励
              <el-select v-model="basicInfoForm.stage_5_coupon" placeholder="请选择">
                <el-option
                  v-for="item in tableData"
                  :key="item.uuid"
                  :label="item.name"
                  :value="item.uuid">
                </el-option>
              </el-select>
            </p>
          </div>
        </el-form-item>
        <el-form-item label="是否开启阶段奖励">
          <el-switch
            v-model="basicInfoForm.is_stage"
            active-value="1"
            inactive-value="0"
            active-color="#13ce66"
            inactive-color="gray"
          >
          </el-switch>
        </el-form-item>
      </el-form>
    </div>
    <div class="operateBtn">
      <el-button size="mini" type="primary" @click="submit">保存</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "invitateIsPolite",
  data() {
    return {
      imageUrl: "",
      isShow: false,
      tableData: [],
      basicInfoForm: {
        coupon_uuid: "",
        day_limit: "",
        stage_1_num: "",
        stage_2_num: "",
        stage_3_num: "",
        stage_4_num: "",
        stage_5_num: "",
        stage_1_coupon: "",
        stage_2_coupon: "",
        stage_3_coupon: "",
        stage_4_coupon: "",
        stage_5_coupon: "",
        is_stage: '1',
      },
    };
  },
  created() {
    this.getCouponList()
    this.axios({
      method: "get", //请求方法
      headers: {
        "Content-Type": "application/json",
        "X-Access-Token": this.storage.get("__token"),
        Authorization: `Bearer ${this.storage.get("__token")}`,
      },
      url: ` https://time.api.boyalife.cn/v1/cms/ItemInviteRule/get`,
    })
      .then((res) => {
        let a = res.data.result;
        for (let i in a) {
          this.basicInfoForm[i] = a[i];
        }
      })
      .catch((err) => {
        this.$message.error(err.response.data.error.message);
      });
  },
  methods: {
    getCouponList() {
      this.axios({
        method: "get", //请求方法
        headers: {
          "Content-Type": "text/html;charset=UTF-8",
          "X-Access-Token": this.storage.get("__token"),
          Authorization: `Bearer ${this.storage.get("__token")}`,
        },
        url: ` https://time.api.boyalife.cn/v1/cms/Coupon?page_index=1&page_size=9999`,
      })
        .then((res) => {
          this.tableData = res.data.result.data;
        })
        .catch((err) => {
          this.$message.error(err.response.data.error.message);
        });
    },
    submit() {
      this.axios({
        method: "put", //请求方法
        headers: {
          "Content-Type": "application/json",
          "X-Access-Token": this.storage.get("__token"),
          Authorization: `Bearer ${this.storage.get("__token")}`,
        },
        data: this.basicInfoForm,
        url: ` https://time.api.boyalife.cn/v1/cms/ItemInviteRule/edit`,
      })
        .then((res) => {
          this.$message.success("保存成功！");
        })
        .catch((err) => {
          this.$message.error(err.response.data.error.message);
        });
    },
  },
};
</script>
<style scoped>
.invitateIsPolite {
  background: #f2f2f2;
  margin-bottom: 80px;
}
.basicInfo {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
}
.avatar-uploader >>> .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.el-form {
  width: 100%;
}
>>> .ipt {
  width: 200px;
  margin: 0 10px;
}
>>> .el-checkbox {
  margin-right: 0;
}
p {
  line-height: 40px;
}
</style>
